import { apiClient } from '@/shared/api';
import type {
  AllAuditLogsResponse,
  AuditLogEntry,
  AuditLogEntryWithNames,
  AuditLogExportResponse,
  AuditLogFilters,
} from '@aegislab/shared';

export type {
  AuditLogEntry,
  AuditLogEntryWithNames,
  AllAuditLogsResponse,
  AuditLogExportResponse,
  AuditLogFilters,
};

// X3 단계 1a (D4): attendance audit read 흡수. 호출자 갱신은 단계 1d.
// 데이터 범위는 attendance 도메인 전용 (table: attendance_audit_logs).
export const fetchAuditLogs = async (attendanceId: string): Promise<AuditLogEntry[]> => {
  const response = await apiClient.get<AuditLogEntry[]>(`/attendance/${attendanceId}/audit-logs`);
  return response.data;
};

export const fetchAllAuditLogs = async (
  limit = 100,
  offset = 0,
  search?: string,
  action?: string,
  filters: Pick<AuditLogFilters, 'userId' | 'startDate' | 'endDate'> = {}
): Promise<AllAuditLogsResponse> => {
  const response = await apiClient.get<AllAuditLogsResponse>('/attendance/audit-logs', {
    params: {
      limit,
      offset,
      search,
      action,
      userId: filters.userId,
      startDate: filters.startDate,
      endDate: filters.endDate,
    },
  });
  return response.data;
};

/**
 * 내보내기 전용 — 화면 페이지(100건)와 달리 필터 조건 전체를 받는다.
 * 상한에서 잘리면 truncated 가 true 로 온다.
 */
export const fetchAuditLogsForExport = async (
  filters: AuditLogFilters = {}
): Promise<AuditLogExportResponse> => {
  const response = await apiClient.get<AuditLogExportResponse>('/attendance/audit-logs/export', {
    params: filters,
  });
  return response.data;
};

export const auditLogApi = {
  fetchAuditLogs,
  fetchAllAuditLogs,
  fetchAuditLogsForExport,
};
